import { render, staticRenderFns } from "./mediaIndex.vue?vue&type=template&id=3994b4d0&scoped=true"
import script from "./mediaIndex.vue?vue&type=script&lang=js"
export * from "./mediaIndex.vue?vue&type=script&lang=js"
import style0 from "./mediaIndex.vue?vue&type=style&index=0&id=3994b4d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3994b4d0",
  null
  
)

export default component.exports